<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-button class="btn-round"
                          :variant="(isOpenFormAddNew ? 'danger' : 'primary')"
                          @click="showAndHideForm">
                    {{ (isOpenFormAddNew ? "close" : "+ Add advertisement")}}
                </b-button>
            </template>
        </navbar>
        <!--END Navbar-->

        <b-card title="Add" v-if="isOpenFormAddNew">
            <template v-if="editedItemId > 0">
                <b-form-group
                        :state="!validation.hasError('title')"
                        :invalid-feedback="validation.errorTitle('title')"
                >
                    <b-input v-model="form.title" placeholder="title"></b-input>
                </b-form-group>
                <b-form-group
                        :state="!validation.hasError('image')"
                        :invalid-feedback="validation.errorTitle('image')"
                >
                    <b-form-file v-model="form.image" @change="onSelectFile"></b-form-file>
                </b-form-group>
                <template v-if="previewUrl !== null">
                    <b-img width="120" :src="previewUrl" alt=""></b-img>
                </template>
                <br>
                <br>
                <b-button @click="updateAdvertisement" variant="success">save</b-button>
            </template>

            <template v-else>
                <b-form-group
                        :state="!validation.hasError('title')"
                        :invalid-feedback="validation.errorTitle('title')"
                >
                    <b-input v-model="form.title" placeholder="title"></b-input>
                </b-form-group>
                <b-form-group
                        :state="!validation.hasError('image')"
                        :invalid-feedback="validation.errorTitle('image')"
                >
                    <b-form-file v-model="form.image" @change="onSelectFile"></b-form-file>
                </b-form-group>
                <template v-if="previewUrl !== null">
                    <b-img width="120" :src="previewUrl" alt=""></b-img>
                </template>
                <br>
                <br>
                <b-button @click="storeAdvertisement" variant="success">save</b-button>
            </template>

        </b-card>
        <!--END Form-->

        <template v-if="items.length > 0">
            <b-card v-for="(item,index) in items"
                    :key="index">
                <b-media>
                    <template #aside>
                        <b-img :src="item.image_url" width="64" alt="placeholder"></b-img>
                    </template>

                    <h5 class="mt-0">{{item.title}}</h5>
                    <p class="mb-0">
                        <span class="ml-4 text-primary">
                            <a @click.prevent="editItem(item)" href="#">
                                <span class="material-icons">edit</span>
                            </a>
                            <a class="text-danger ml-3"
                               @click.prevent="deleteAdvertisement(item.id)"
                               href="#">
                                <span class="material-icons">delete</span>
                            </a>
                            <a class="ml-4" href="#"
                               @click.prevent="doCopy(item.image_url)">copy url</a>
                        </span>
                    </p>
                </b-media>
            </b-card>
        </template>

    </div>
</template>

<script>

    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notificaion from '../../Services/Notification/Nottification'
    import Validation from '../../Services/Validation/Validation'


    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                validation: new Validation(),
                isOpenFormAddNew: false,
                dictionary: null,
                previewUrl: null,
                items: [],
                form: {
                    title: null,
                    image: null,
                },
                editedItemId: null,
            }
        },
        methods: {
            doCopy(myText) {
                let myThis = this;
                this.$copyText(myText).then(function (e) {
                    Notificaion.success("Copied")
                }, function (e) {
                    Notificaion.error("Can not copy")
                })
            },
            onSelectFile(event) {
                this.previewUrl = URL.createObjectURL(event.target.files[0]);
            },
            showAndHideForm() {
                this.isOpenFormAddNew = !this.isOpenFormAddNew;

                if (!this.isOpenFormAddNew) {
                    this.editedItemId = 0;
                }
            },
            editItem(myItem) {
                this.isOpenFormAddNew = true;
                this.editedItemId = myItem.id;
                this.form.title = myItem.title;
            },
            storeAdvertisement() {

                if (this.form.title === null) {
                    Notificaion.error("please enter title");
                    return;
                }

                this.$Progress.start();

                let fd = new FormData();
                fd.append("title", this.form.title);
                fd.append("image", this.form.image);

                Http.post(Http.apiurlV2() + 'advertisement/store', fd)
                    .then(response => {
                        if (response.data.status_code === Http.created()) {
                            this.$Progress.finish();
                            this.editedItemId = 0;
                            this.form.title = null;
                            this.form.image = null;
                            this.previewUrl = null;
                            this.isOpenFormAddNew = false;
                            this.getAdvertisements();
                            Notificaion.success(response.data.message)
                        }else {
                            this.validation.store(response.data.data);
                            Notificaion.error(response.data.message)
                            this.$Progress.finish();
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getAdvertisements() {
                this.$Progress.start();
                Http.get(Http.apiurl() + 'advertisement/index')
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.items = response.data.data;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },

            updateAdvertisement() {

                if (this.form.title === null) {
                    Notificaion.error("please enter title");
                    return;
                }

                this.$Progress.start();

                let fd = new FormData();
                fd.append("title", this.form.title);
                if (this.form.image !== null) {
                    fd.append("image", this.form.image);
                }

                Http.post(Http.apiurlV2() + 'advertisement/update/' + this.editedItemId, fd)
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.getAdvertisements();
                            this.editedItemId = 0;
                            this.form.title = null;
                            this.form.image = null;
                            this.form.previewUrl = null;
                            this.isOpenFormAddNew = false;
                            Notificaion.success(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            deleteAdvertisement(id) {
                if (confirm("Are you sure delete this item ?")) {
                    this.$Progress.start();
                    Http.get(Http.apiurl() + 'advertisement/delete/' + id)
                        .then(response => {
                            if (response.data.status_code === Http.ok()) {
                                this.$Progress.finish();
                                this.getAdvertisements();
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
        },
        created() {
            this.getAdvertisements();
        }

    }
</script>

<style scoped>

</style>